// extracted by mini-css-extract-plugin
export default {"cls1":"Avatar-cls1_ghP","cls2":"Avatar-cls2_YYm Avatar-cls1_ghP"};